namespace $ {

	/** Bounded immutable content page for an oversized history event. */
	export class $shm_hitalama_map_history_event_parts extends $giper_baza_dict_to( $giper_baza_atom_text ) {}

}
